import styled, { css } from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

export const StyledVisitTemplateReadOnlyText = styled.div<{ asPlaceholder: boolean }>`
   ${basicBodyTextStyle};
   margin-top: 8px;
   word-break: break-word;
   overflow-y: auto;
   white-space: pre-wrap;
   padding-right: 7px;

   ${(props) =>
      props.asPlaceholder &&
      css`
         color: ${props.theme.disabled};
      `}
`;
StyledVisitTemplateReadOnlyText.displayName = 'StyledVisitTemplateReadOnlyText';
